import { createNode } from '@glueapp/graph-types';

export const TrimStart = createNode({
    id: 'Trim Start',
    name: 'Trim Start',
    description: 'Removes all whitespace characters from the beginning of the input text',
    aiDescription: 'Strips leading whitespace from a string. Connect a string to "Input"; outputs the trimmed string on "Output".',
    category: 'Text',
    color: '#387cc8',
    integration: undefined,
    inPorts: {
        Input: { kind: 'string' },
    },
    outPorts: {
        Output: { kind: 'string' },
    },
    execute: function (input) {
        return { output: { Output: input.inPorts.Input.trimStart() } };
    },
});
